import { useErrorDisplay, IReactBaseProps } from '@gcl/react-core';
import { IProjectUserProfile } from '@userProfile/projectUserProfile.models';

import * as React from 'react';
import { IRolePermissionFlattened } from '@permission/permission.models';
import { v4 as uuidv4 } from 'uuid';
import { IProject } from 'src/project/project.models';
import { IUserProfile } from '@userProfile/userProfile.models';
import { IProjectCompanyBase } from '@company/projectCompany/projectCompany.models';
import { IProjectTeamBase } from '@projectTeam/projectTeam.models';
import { IAppConfigContext, AppConfigs } from './config.models';
import { IEnvConfigs, envConfigs } from './envConfigs';

const traceId = uuidv4();

export interface IGems2AppConfig extends IEnvConfigs {
  myProjectUserProfile?: IProjectUserProfile;
  myPermissions?: IRolePermissionFlattened[];
  myUserProfile?: IUserProfile;
  myCompanies?: IProjectCompanyBase[];
  myTeams?: IProjectTeamBase[];
  projectNoFromUrl?: string;
  project?: IProject;
  isAnyActionLoading?: boolean;
  isDetailPageDrawerOpen?: boolean;
}

export const AppConfigContext = React.createContext<IAppConfigContext<IGems2AppConfig>>({
  configs: { traceId, ...envConfigs },
  updateConfigs: () => {},
});

export interface IAppConfigProps extends IReactBaseProps {}

export const AppConfig: React.FunctionComponent<IAppConfigProps> = ({ children }) => {
  const configErrors = Object.entries(envConfigs).reduce((results: any[], [key, value]) => {
    if (value === undefined)
      results.push({
        name: 'App config error',
        message: `${key} is missing`,
      });
    return results;
  }, []);
  useErrorDisplay(configErrors.length > 0 ? configErrors : undefined);
  const [appConfigs, setAppConfigs] = React.useState<AppConfigs<IGems2AppConfig>>({
    traceId,
    ...envConfigs,
  });

  const defaultAppConfigs = React.useMemo(
    () => ({ configs: appConfigs, updateConfigs: setAppConfigs }),
    [JSON.stringify(appConfigs)],
  );

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <AppConfigContext.Provider value={defaultAppConfigs}>{children}</AppConfigContext.Provider>
  );
};
